import _ from 'lodash';
import { browserHistory } from 'react-router';
import * as isMobileUtil from 'ismobilejs';

export const isMobile = isMobileUtil;
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
export const USERNAME_REGEX = /^[0-9a-zA-Z-_]+$/;

class StatusError extends Error {
  constructor(status, statusText, response) {
    if (!response || !response.message) {
      super(statusText);
    } else {
      super(response.message);
    }
    if (response.type) this.type = response.type;
    this.status = status;
    this.statusText = status;
    this.response = response;
  }
}

export const getDynamicClasses = classes =>
  classes
    .map(c => (c[0] ? c[1] : c[2]))
    .filter(c => c !== '' && c !== undefined && c !== null)
    .join(' ');

export function createReducer(initialState, reducerMap) {
  return (state = initialState, action) => {
    const reducer = reducerMap[action.type];
    return reducer ? reducer(state, action.payload) : state;
  };
}

export function checkHttpStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  const { status, statusText } = response;

  return response
    .json()
    .then((response) => {
      var error = new StatusError(status, statusText, response);
      throw error;
    })
    .catch((error) => {
      if (!error instanceof StatusError) {
        error = new StatusError(status, statusText, response);
      }
      throw error;
    });
}

export function parseJSON(response) {
  return response.json();
}

export function parseText(response) {
  return response.text();
}

export function decodeHTMLEntities(str) {
  var element = document.createElement('div');
  if (str && typeof str === 'string') {
    // strip script/html tags
    str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '');
    str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '');
    element.innerHTML = str;
    str = element.textContent;
    element.textContent = '';
  }

  return str;
}

export function formatNumber(number) {
  if (isNaN(number)) {
    return 0;
  }

  return number.toLocaleString();
}

export function isEmail(email) {
  if (!email.match(EMAIL_REGEX)) {
    return false;
  } else {
    return true;
  }
}

export function getFlashVersion() {
  try {
    try {
      // avoid fp6 minor version lookup issues
      // see: http://blog.deconcept.com/2006/01/11/getvariable-setvariable-crash-internet-explorer-flash-6/
      var axo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash.6');
      try {
        axo.AllowScriptAccess = 'always';
      } catch (e) {
        return '6,0,0';
      }
    } catch (e) {
    }

    return new ActiveXObject('ShockwaveFlash.ShockwaveFlash')
      .GetVariable('$version')
      .replace(/\D+/g, ',')
      .match(/^,?(.+),?$/)[1];
    // other browsers
  } catch (e) {
    try {
      if (navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin) {
        return (
          navigator.plugins['Shockwave Flash 2.0'] ||
          navigator.plugins['Shockwave Flash']
        ).description
          .replace(/\D+/g, ',')
          .match(/^,?(.+),?$/)[1];
      }
    } catch (e) {
    }
  }
  return '0,0,0';
}

export function isArrayEqual(x, y) {
  if (x.length !== y.length) return false;
  return _(x)
    .differenceWith(y, _.isEqual)
    .isEmpty();
}

export function offsetFromWrapper($element) {
  return $element.offset().top - $('.main-content')
    .offset().top;
}

export function generateSnapshotUrl(template, timestamp, full) {
  if (full) {
    return `https://snapshots.explore.org/${template}-EDGE/${template}-EDGE-${timestamp}.jpg`;
  }
  return `https://snapshots.explore.org/${template}-EDGE/${template}-EDGE-${timestamp}-scaled.jpg`;
}

export const BACKGROUND_COLOR = 'C';
export const BACKGROUND_WHITE = 'W';
export const BACKGROUND_GREY = 'G';

export function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+')
    .replace('_', '/');
  return JSON.parse(window.atob(base64));
}

function extractHostname(url) {
  let hostname;
  if (url.indexOf('//') > -1) {
    hostname = url.split('/')[2];
  } else {
    hostname = url.split('/')[0];
  }
  hostname = hostname.split(':')[0];
  hostname = hostname.split('?')[0];
  return hostname;
}

export function extractRootDomain(url) {
  let domain = extractHostname(url);
  const splitArr = domain.split('.');
  const arrLen = splitArr.length;

  if (arrLen > 2) {
    domain = `${splitArr[arrLen - 2]}.${splitArr[arrLen - 1]}`;
    if (splitArr[arrLen - 2].length === 2 && splitArr[arrLen - 1].length === 2) {
      domain = `${splitArr[arrLen - 3]}.${domain}`;
    }
  }
  return domain;
}

export function slugify(text) {
  return text.toString()
    .toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

/**
 * @param {Object} query
 */
export const addQuery = (query) => {
  const location = Object.assign({}, browserHistory.getCurrentLocation());
  Object.assign(location.query, query);
  browserHistory.push(location);
};

/**
 * @param {...String} queryNames
 */
export const removeQuery = (...queryNames) => {
  const location = Object.assign({}, browserHistory.getCurrentLocation());
  queryNames.forEach(q => delete location.query[q]);
  browserHistory.push(location);
};

/**
 * Returns the pixel density ratio taking into account if the screen is zoomed in or not
 */
export function getPixelDensityRatio() {
  let ratio = 1;

  // rule out server-side rendering
  if (typeof window === 'undefined') {
    return ratio;
  }

  // To account for zoom, change to use deviceXDPI instead of systemXDPI
  if (
    window.screen.systemXDPI !== undefined
    && window.screen.logicalXDPI !== undefined
    && window.screen.systemXDPI > window.screen.logicalXDPI
  ) {
    // Only allow for values > 1
    ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
  } else if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio;
  }
  return ratio;
}

/**
 * Given a target width and an imageSet (array of like images with the width as keys)
 * this will run through the image set and find the equal next widest image available.
 * This will also take into account pixel density to determine if it should select
 * retina/high definition versions of the image.
 */
export function imageFromSetByDimension(target, imgSet) {
  // Check the pixel density and adjust the target dimension accordingly.
  // Some mobile devices have a pixel ratio of 3.5. The difference between
  // a ratio of 2 vs 3.5 is not worth the extra download time, especially
  // over a mobile connection. limit it to 2.
  const ratio = getPixelDensityRatio();
  target = (ratio > 2.0) ? target * 2 : target * ratio;

  // lazy check first
  if (typeof imgSet[target] !== 'undefined') {
    return imgSet[target];
  }

  // get the keys from the object, parse them to integers, and sort lowest to highest
  const keys = Object.keys(imgSet)
    .map(key => parseInt(key, 10))
    .sort((a, b) => a - b);

  // find the next highest element
  const nextHighestMatch = keys.find(key => key >= target);

  // if target is higher than any available dimension send the highest we have
  return (nextHighestMatch) ? imgSet[nextHighestMatch] : imgSet[keys.pop()];
}

export const hlsStreamLatency = 23;

export const makeCancelable = (promise) => {
  let hasCanceled_ = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      val => hasCanceled_ ? reject({ isCanceled: true }) : resolve(val),
      error => hasCanceled_ ? reject({ isCanceled: true }) : reject(error)
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    },
  };
};

export const getPagePath = () => window.location.pathname + window.location.search;

export const isSubdomain = document.location.href.includes('dev') ||
  document.location.href.includes('local') ||
  document.location.href.includes('stage');

export const possessive = (noun) => {
  if (typeof noun !== 'string') throw new TypeError('Value passed must be a string');
  if (noun.length === 0) throw new Error('Cannot make empty string possessive');
  if (noun.toLowerCase()
    .endsWith('s')) {
    return `${noun}'`;
  }
  return `${noun}'s`;
};

/* global COMMENTS_GQL, COMMENTS_CLIENT_ID, COMMENTS_PUSHER_APP_KEY, COMMENTS_PUSHER_APP_CLUSTER, COMMENTS_WEBSOCKET_HOST, COMMENTS_CLOUDFRONT_URL */

export const commentsConfig = () => {
  return {
    gqlUri: COMMENTS_GQL,
    clientId: COMMENTS_CLIENT_ID,
    pusherKey: COMMENTS_PUSHER_APP_KEY,
    pusherCluster: COMMENTS_PUSHER_APP_CLUSTER,
    websocketHost: COMMENTS_WEBSOCKET_HOST,
    cloudfrontUri: COMMENTS_CLOUDFRONT_URL,
  };
};
